import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import CardWithLogo from 'components/CardWithLogo';
import Loader from 'ui/Loader';
import { NEW_VENDOR_BO_PAGE } from 'pages/SoBoPages/NewVendor/lib';
import { getOrganizationDataForBoPage } from 'api/organizations';
import StageOne from 'pages/SoBoPages/NewVendor/stageOne';
import StageTwo from 'pages/SoBoPages/NewVendor/stageTwo';
import StageThree from 'pages/SoBoPages/NewVendor/stageThree';
import StageFour from 'pages/SoBoPages/stageFour';
import { translate } from 'utils/index';
import { messages } from 'pages/SoBoPages/NewVendor/messages';
import { LOGO_BASE_URL } from 'constants/general';
import { resetState } from 'pages/SoBoPages/reducers';
import { selectSoBoPages } from 'pages/SoBoPages/selectors';
import { useAppNavigate } from 'hooks/navigation';
import ROUTES from 'constants/routes';

import ladyWithKite from 'assets/svgs/lady-with-kite.svg';
import findingsLogo from 'assets/svgs/logo-white.svg';
import './index.scss';

const NewVendorBoPage = () => {
  const dispatch = useDispatch();
  const appNavigate = useAppNavigate();
  const {
    additionalData: { logo, status },
  } = useSelector(selectSoBoPages);
  const { organizationId } = useParams();
  const [stage, setStage] = useState(NEW_VENDOR_BO_PAGE.STAGE_1);

  const getData = async () => {
    await dispatch(resetState());
    await dispatch(getOrganizationDataForBoPage(organizationId));
  };

  useEffect(() => {
    getData().then();
  }, []);

  const logoPath = useMemo(() => `${LOGO_BASE_URL}${logo}`, [logo]);

  const textComponent = useMemo(() => {
    switch (stage) {
      case NEW_VENDOR_BO_PAGE.STAGE_1:
        return <StageOne.Description />;
      case NEW_VENDOR_BO_PAGE.STAGE_2:
        return <StageTwo.Description />;
      case NEW_VENDOR_BO_PAGE.STAGE_3:
        return <StageThree.Description />;
      default:
        return <div />;
    }
  }, [stage]);

  const cardContentComponent = useMemo(() => {
    switch (stage) {
      case NEW_VENDOR_BO_PAGE.STAGE_1:
        return <StageOne setStage={setStage} />;
      case NEW_VENDOR_BO_PAGE.STAGE_2:
        return <StageTwo setStage={setStage} />;
      case NEW_VENDOR_BO_PAGE.STAGE_3:
        return <StageThree setStage={setStage} />;
      default:
        return <div />;
    }
  }, [stage]);

  const onClickOkStageFour = async () => {
    await getData();
    setStage(NEW_VENDOR_BO_PAGE.STAGE_1);
  };

  const onClickCloseStageFour = async () => {
    await getData();
    setStage(NEW_VENDOR_BO_PAGE.STAGE_1);
    appNavigate(ROUTES.VENDOR_RECENT);
  };

  return status ? (
    <div className="bo-page">
      {stage === NEW_VENDOR_BO_PAGE.STAGE_4 ? (
        <StageFour
          image={ladyWithKite}
          setStage={setStage}
          okButtonText={translate(messages.stageFourOkButton)}
          okButtonOnClick={onClickOkStageFour}
          closeButtonClick={onClickCloseStageFour}
        />
      ) : (
        <CardWithLogo
          logo={findingsLogo}
          className="bo-page__card"
          leftAreaClassName="bo-page__card-left-area"
          leftComponent={textComponent}
        >
          <img src={logoPath} alt="logo" width="200" height="auto" />
          {cardContentComponent}
        </CardWithLogo>
      )}
    </div>
  ) : (
    <Loader />
  );
};

export default NewVendorBoPage;
